import {useState} from "react";

export function useBusy(): { isBusy: boolean; setIsBusy: (busy: boolean) => void } {
    const [isBusy, setIsBusy] = useState(false);
    return {
        isBusy,
        setIsBusy,
    };
}
